module.exports = __webpack_public_path__ + "media/images/whats-c3ad6900648c637e1a7f078ef4ebd7a9.png";